import { FC } from 'react'
import Image from 'next/image'

import { squigglyArrowDecoration, atomThumbsUp } from '@ui/assets'

export const BrighterFuture: FC = () => {
  return (
    <section className="relative overflow-hidden bg-gradient-to-b from-sky-50 to-white py-24">
      <div className="absolute right-0 top-0 h-[800px] w-[800px] rounded-full bg-sky-100/40" />

      <div className="relative z-10 mx-auto max-w-7xl pl-0 pr-4 text-center sm:px-6 lg:px-8">
        <h2 className="font-display relative ml-2 text-5xl leading-[0.9] tracking-[-3.6px] text-[#0a2d4a] md:ml-0 md:text-7xl lg:text-[120px]">
          <span className="relative inline-block">
            A Brighter
            {/* Squiggly arrow decoration above "brighter" */}
            <span className="absolute right-[10%] top-[-40px] inline-block w-[80px] rotate-45 lg:right-[20%] lg:top-[-60px] lg:w-[148px]">
              <Image
                src={squigglyArrowDecoration}
                width={148}
                height={148}
                alt=""
              />
            </span>
          </span>
          <br />
          <span className="relative inline-flex items-center space-x-0 lg:-space-x-4">
            Financial
            {/* Atom thumbs up between Financial & Future */}
            <span className="relative inline-block h-[80px] w-[80px] lg:h-[150px] lg:w-[150px]">
              <Image
                src={atomThumbsUp}
                width={150}
                height={150}
                alt=""
                className="h-full w-full object-contain"
              />
            </span>
            Future
          </span>
          <br />
          <span className="relative inline-block text-[#29bfed]">
            starts here
            {/* Squiggly decoration below "here" */}
            <span className="absolute left-[50%] top-full mt-0 inline-block w-[120px] lg:left-auto lg:right-8 lg:w-[209px]">
              <svg
                preserveAspectRatio="none"
                width="100%"
                height="100%"
                overflow="visible"
                style={{ display: 'block' }}
                viewBox="0 0 213 30"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M2.00051 26.2206L16.5832 19.871C25.2847 16.0822 34.6119 13.6819 44.0933 14.0993C48.0704 14.2744 49.8913 14.6246 51.3546 15.0151C53.9066 15.6961 55.441 16.889 56.4289 18.3343C59.211 22.4043 58.5586 27.0779 58.5936 27.6096C58.6482 28.4389 60.6681 24.4803 63.9438 20.9552C65.8689 18.8836 68.6902 16.5898 71.0778 14.8729C73.4653 13.156 75.4263 12.1755 77.592 11.3202C79.7578 10.4649 82.0689 9.7646 84.31 9.22873C86.5511 8.69286 88.6521 8.34268 90.715 8.16229C92.7778 7.9819 94.7388 7.9819 96.6244 8.12197C100.275 8.39315 103.395 9.25101 105.832 10.1328C107.869 10.8701 109.064 12.15 109.806 13.279C111.057 15.1833 110.766 16.889 110.941 17.3888C111.327 18.4892 112.528 14.4293 114.219 12.2784C115.167 11.0728 116.471 9.77733 118.101 8.46153C119.73 7.14573 121.691 5.88511 123.752 4.85051C125.813 3.81592 127.914 3.04554 130.187 2.57864C132.46 2.11175 134.841 1.97168 137.223 2.00457C139.605 2.03747 141.916 2.24757 144.158 2.60093C146.399 2.95428 148.5 3.44452 150.387 4.04724C153.944 5.18275 156.526 6.77222 158.292 8.21853C159.86 9.50313 160.635 11.8593 161.622 13.5602C162.271 14.679 164.871 11.7404 167.831 9.83569C169.488 8.77015 171.632 7.7909 174.08 6.86453C176.528 5.93817 179.26 5.16779 182.137 4.63086C185.015 4.09393 187.957 3.81379 190.698 3.80955C193.438 3.8053 195.89 4.08544 198.098 4.47488C202.227 5.20301 205.196 6.34989 207.173 7.37281C208.099 7.9055 208.869 8.46577 209.336 8.85945C209.803 9.25313 209.943 9.46323 210.088 9.6797"
                  stroke="#29BFED"
                  strokeWidth="4"
                  strokeLinecap="round"
                  strokeDasharray="400"
                  style={{
                    transition: 'stroke-dashoffset 0.3s ease-out',
                  }}
                />
              </svg>
            </span>
          </span>
        </h2>
      </div>
    </section>
  )
}
